import { useState, useEffect, useRef, useMemo, forwardRef } from 'react';
import "./AnimatedIconButton.style.css";
import { SvgComponent } from '../SvgComponent/SvgComponent';
import ToolTip from '../ToolTip/Tooltip';
import { useTheme } from '../../Hooks';
export const AnimatedIconButton = ({
    onClick,
    style,
    style2,
    size,
    disabled = false,
    iconName = "Grabar",
    width = "24px",
    height = "24px",
    message,
    placement,
    isWhite = false,
    useVendorTheme = false,
    id = "",
    clicked = false
  }) => {
    const [svgClass, setSvgClass] = useState("animated-button");
    const [divClass, setDivClass] = useState("animated-div");
    const [color1, setColor1] = useState(window.color1);
    useEffect(() => {
      if(useVendorTheme){
        if(window.esClaro){
          setColor1('#D52B1E')
        }else{
          setColor1('rgb(241, 97, 1)')
        }
      }
    }, [])
    useEffect(() => {
        if(clicked === false){
            setSvgClass("animated-button");
            setDivClass("animated-div");
        }else{
            setSvgClass("animated-button-hover");
            setDivClass("animated-div-hover");
        }
    }, [clicked]);
    return (
      <div style={style2}>
        {message ? (
          <ToolTip message={message} placement={placement}>
            <button
              type="button"
              onClick={onClick}
              className={`bootstrapiso animated-button ${disabled && "disabled"}`}
              style={style}
              disabled={disabled}
            >
              <div
                className={divClass}
                style={{
                  ...style,
                  height: size,
                  width: size,
                  backgroundColor:
                    divClass == "animated-div-hover"
                      ? color1
                      : isWhite
                      ? "white"
                      : "transparent",
                  borderColor: color1,
                }}
                onMouseEnter={() => {
                  setSvgClass("animated-button-hover");
                  setDivClass("animated-div-hover");
                }}
                onMouseLeave={() => {
                    if(!clicked){
                        setSvgClass("animated-button");
                        setDivClass("animated-div");
                    }
                }}
              >
                <SvgComponent
                  height={height}
                  width={width}
                  iconName={iconName}
                  fill={color1}
                  className={svgClass}
                  id={id}
                />
              </div>
            </button>
          </ToolTip>
        ) : (
          <button
            type="button"
            onClick={onClick}
            className={`bootstrapiso animated-button ${disabled && "disabled"}`}
            style={style}
            disabled={disabled}
          >
            <div
              className={divClass}
              style={{
                ...style,
                height: size,
                width: size,
                backgroundColor:
                  divClass == "animated-div-hover"
                    ? color1
                    : isWhite
                    ? "white"
                    : "transparent",
                borderColor: color1,
              }}
              onMouseEnter={() => {
                setSvgClass("animated-button-hover");
                setDivClass("animated-div-hover");
              }}
              onMouseLeave={() => {
                  if(!clicked){
                      setSvgClass("animated-button");
                      setDivClass("animated-div");   
                  }
              }}
            >
              <SvgComponent
                height={height}
                width={width}
                iconName={iconName}
                fill={color1}
                className={svgClass}
                id={id}
              />
            </div>
          </button>
        )}
      </div>
    );
  };
  